import PropTypes from 'prop-types';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import MKBox from 'components/MKBox';
import MKTypography from 'components/MKTypography';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

function HorizontalTeamCard({ image, name, position, description, linkedin }) {
  return (
    <Card sx={{ mt: 3 }}>
      <Grid container>
        <Grid item xs={12} md={6} lg={4} sx={{ mt: -6 }}>
          <MKBox width="100%" pt={2} pb={1} px={2}>
            <MKBox
              component="img"
              src={image}
              alt={name}
              width="127.44px"
              height="127.44px"
              sx={{ borderRadius: '7%' }} // evita deformación
              shadow="lg"
              // position="relative"
              // textAlign="left"
            />
          </MKBox>
        </Grid>
        <Grid item xs={12} md={6} lg={8} sx={{ my: 'auto' }}>
          <MKBox
            pt={1}
            pb={2.5}
            pr={4}
            pl={{ xs: 4, lg: 1 }}
            lineHeight={1}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center', // Aseguramos que el contenido esté centrado verticalmente
              alignItems: 'flex-start', // Alineamos todo al inicio (izquierda)
              textAlign: 'left', // Forzamos la alineación a la izquierda
            }}
          >
            <MKTypography variant="h5" sx={{ textAlign: 'left', margin: 0 }}>
              {name}
            </MKTypography>
            <MKTypography variant="h6" color={position.color} mb={1}>
              {position.label}
            </MKTypography>
            {linkedin ? (
              <MKBox
                component="a"
                href={linkedin}
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: '#0e76a8',
                  display: 'flex',
                  alignItems: 'center',
                  textDecoration: 'none',
                }}
              >
                <LinkedInIcon />
              </MKBox>
            ) : (
              <MKBox
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  color: '#0e76a8',
                  opacity: 0.5,
                  mt: 1,
                }}
              >
                <LinkedInIcon sx={{ mr: 1 }} />
              </MKBox>
            )}
          </MKBox>
        </Grid>
      </Grid>
    </Card>
  );
}

// Typechecking props for the HorizontalTeamCard
HorizontalTeamCard.propTypes = {
  image: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  position: PropTypes.shape({
    color: PropTypes.oneOf([
      'primary',
      'secondary',
      'info',
      'success',
      'warning',
      'error',
      'dark',
      'light',
    ]).isRequired,
    label: PropTypes.string.isRequired,
  }).isRequired,
  linkedin: PropTypes.string,
};

export default HorizontalTeamCard;
